import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core'
import { AssetLoaderService } from '../../services/asset-loader.service'
import { RouterOutlet, Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs'
import { ScriptLoaderService } from '../../services/script-loader.service'

@Component({
  standalone: true,
  selector: 'app-hrms-layout',
  templateUrl: './hrmsLayout.component.html',
  imports: [RouterOutlet],
  styleUrls: ['./hrmsLayout.component.scss']
})
export class HrmsLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private assetLoader: AssetLoaderService,
    private renderer: Renderer2,
    router: Router,
    private scriptLoader: ScriptLoaderService
  ) {
    // router.events.subscribe(e => {
    //   console.log(router.url)
    // })
    // router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
    //   console.log('Final URL:', router.url)
    // })
  }

  // ngOnInit() {
  //   // this.assetLoader.loadCss('hrms-bootstrap', 'assets/hrms/css/bootstrap.min.css')
  //   // this.assetLoader.loadCss('hrms-style', 'assets/hrms/css/style.css')
  //   // this.assetLoader.loadScript('jquery', 'assets/hrms/js/jquery.min.js')
  //   // this.assetLoader.loadScript('select2', 'assets/hrms/js/select2.min.js')
  //   // this.assetLoader.loadScript('summernote', 'assets/hrms/js/summernote-lite.min.js')

  //   this.loadStyle('hrms-animate', 'assets/css/animate.css')
  //   this.loadStyle('hrms-feather', 'assets/plugins/icons/feather/feather.css')
  //   this.loadStyle('hrms-tabler-icons', 'assets/plugins/tabler-icons/tabler-icons.css')
  //   this.loadStyle('hrms-fontawesome', 'assets/plugins/fontawesome/css/fontawesome.min.css')
  //   this.loadStyle('hrms-fontawesome-all-min', 'assets/plugins/fontawesome/css/all.min.css')
  //   this.loadStyle('hrms-line-asesome-min', 'assets/css/line-awesome.min.css')
  //   this.loadStyle('hrms-material', 'assets/css/material.css')
  //   this.loadStyle('hrms-morris', 'assets/plugins/morris/morris.css')
  //   this.loadStyle('hrms-daterangepicker', 'assets/plugins/daterangepicker/daterangepicker.css')
  //   this.loadStyle(
  //     'hrms-bootstrap-tagsinput',
  //     'assets/plugins/bootstrap-tagsinput/bootstrap-tagsinput.css'
  //   )
  //   this.loadStyle(
  //     'hrms-bootstrap-datetimepicker-min',
  //     'assets/css/bootstrap-datetimepicker.min.css'
  //   )

  //   this.loadStyle('hrms-summernote-lite', 'assets/plugins/summernote/summernote-lite.min.css')
  //   this.loadStyle('hrms-style', 'assets/css/style.css')

  //   // this.loadScript('theme-script', 'assets/js/theme-script.js')
  //   // this.loadScript(
  //   //   'email-decode',
  //   //   'assets/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js'
  //   // )
  //   // this.loadScript('feather', 'assets/js/feather.min.js')
  //   // this.loadScript('slimscroll', 'assets/js/jquery.slimscroll.min.js')
  //   // this.loadScript('apexchart', 'assets/plugins/apexchart/apexcharts.min.js')
  //   // this.loadScript('apex-chart-data', 'assets/plugins/apexchart/chart-data.js')
  //   // this.loadScript('chartmin', 'assets/plugins/chartjs/chart.min.js')
  //   // this.loadScript('chart-data', 'assets/plugins/chartjs/chart-data.js')
  //   // this.loadScript('moment', 'assets/js/moment.js')
  //   // // this.loadScript('bootstrap-datetimepicker', 'assets/js/bootstrap-datetimepicker.min.js')
  //   // this.loadScript('daterangepicker', 'assets/plugins/daterangepicker/daterangepicker.js')
  //   // this.loadScript('summernote', 'assets/plugins/summernote/summernote-lite.min.js')
  //   // this.loadScript(
  //   //   'bootstrap-tagsinput',
  //   //   'assets/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js'
  //   // )
  //   // this.loadScript('select2', 'assets/plugins/select2/js/select2.min.js')
  //   // this.loadScript('todo', 'assets/js/todo.js')
  //   // this.loadScript('theme-colorpicker', 'assets/js/theme-colorpicker.js')
  //   // this.loadScript('jquery-dataTables', 'assets/js/jquery.dataTables.min.js')
  //   // this.loadScript(
  //   //   'theiaStickySidebar',
  //   //   'assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js'
  //   // )
  //   // this.loadScript('script', 'assets/js/script.js')
  //   // // this.loadScript('dataTables-bootstrap5', 'assets/js/dataTables.bootstrap5.min.js')
  // }

  ngOnInit(): void {
    document.body.classList.add('hrms-theme')
    this.scriptLoader.loadStyles([
      // 'assets/css/style.css'
      // 'assets/plugins/select2/css/select2.min.css',
      // 'assets/plugins/flatpickr/flatpickr.min.css'
    ])
  }

  ngAfterViewInit(): void {
    this.scriptLoader
      .loadScripts([
        'assets/js/jquery.slimscroll.min.js',
        'assets/js/feather.min.js',
        'assets/plugins/apexchart/apexcharts.min.js',
        'assets/plugins/apexchart/chart-data.js',
        'assets/plugins/chartjs/chart.min.js',
        'assets/js/moment.js',
        'assets/js/bootstrap-datetimepicker.min.js',
        'assets/plugins/daterangepicker/daterangepicker.js',
        'assets/plugins/summernote/summernote-lite.min.js',
        'assets/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js',
        'assets/plugins/select2/js/select2.min.js',
        'assets/js/todo.js',
        'assets/js/theme-colorpicker.js',
        'assets/js/script.js',
        'assets/js/jquery.dataTables.min.js',
        'assets/js/dataTables.bootstrap5.min.js',
        'assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js'
      ])
      .then(() => {
        if ((window as any).feather) {
          ;(window as any).feather.replace()
        }
        document.getElementById('pre-hydration-loader')?.remove()
      })
  }

  loadStyle(id: string, href: string) {
    if (!document.getElementById(id)) {
      const link = this.renderer.createElement('link')
      link.id = id
      link.rel = 'stylesheet'
      link.href = href
      this.renderer.appendChild(document.head, link)
    }
  }

  loadScript(id: string, src: string) {
    if (!document.getElementById(id)) {
      const script = this.renderer.createElement('script')
      script.id = id
      script.src = src
      script.async = true
      this.renderer.appendChild(document.body, script)
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('hrms-theme')
    // document.getElementById('hrms-style')?.remove()
  }
}
